import axios from "../../utils/axios";

export const getBlog = async (id) => {
    const response = await axios.get(`/blogs/${id}`);

    return response.data;
};

export const updateBlogAPI = async (id, updatedFields) => {
    const response = await axios.patch(`/blogs/${id}`, updatedFields);

    return response.data;
};